import Vue from 'vue'
import moment from 'moment-timezone'

moment.updateLocale('th', {
  relativeTime: {
    future: '%s',
    past: '%s',
    s: function (number, withoutSuffix, key, isFuture) {
      return number + 's'
    },
    m: '1m',
    mm: function (number, withoutSuffix, key, isFuture) {
      return number + 'm'
    },
    h: '1h',
    hh: '%dh',
    d: '1d',
    dd: '%dd',
    M: '1mo',
    MM: '%dmo',
    y: '1y',
    yy: '%dy'
  }
})

Vue.filter('prettyDate', value => {
  let checkIsValid = moment(value).isValid()
  if (checkIsValid) {
    return moment(value).format('DD MMM YYYY - HH:mm')
  } else {
    return ''
  }
})

Vue.filter('prettyDateFull', value => {
  let checkIsValid = moment(value).isValid()
  if (checkIsValid) {
    return moment(value).format('dddd D MMM YYYY (HH:mm)')
  } else {
    return ''
  }
})

Vue.filter('prettyOnlyDate', value => {
  let checkIsValid = moment(value).isValid()
  if (checkIsValid) {
    return moment(value).format('DD MMM YYYY')
  } else {
    return ''
  }
})

Vue.filter('prettyOnlyTime', value => {
  let checkIsValid = moment(value).isValid()
  if (checkIsValid) {
    return moment(value).format('HH:mm')
  } else {
    return ''
  }
})

Vue.filter('bookingDate', value => {
  return moment(value).format('DD/MM/YYYY - HH:mm')
})

Vue.filter('prettyWorkHours', value => {
  const arr = (value + '').split('.')
  return (arr[1]) ? `${arr[0]} ชม. 30 นาที` : `${arr[0]} ชม.`
})

Vue.filter('relativeTimeSpan', value => {
  return moment(new Date(value)).fromNow()
})

Vue.filter('relativeTimeSpanTicker', value => {
  const pad = (n, width, z) => {
    z = z || '0'
    n = n + ''
    return n.length >= width ? n : new Array(width - n.length + 1).join(z) + n
  }
  let seconds = value
  const hours = Math.floor(seconds / 3600)
  seconds -= (hours * 3600)
  const minutes = Math.floor(seconds / 60)
  seconds -= (minutes * 60)
  return `${pad(hours, 2)}:${pad(minutes, 2)}:${pad(seconds, 2)}`
})

Vue.filter('chatDateTime', value => {
  const a = moment().format('DD/MM/YYYY')
  const b = moment(value).format('DD/MM/YYYY')
  if (a === b) {
    return moment(value).format('HH:mm')
  } else {
    return moment(value).format('DD MMM YYYY - HH:mm')
  }
})

Vue.filter('shortText', (value, limit) => {
  if (value && value.length > limit) {
    return value.substr(0, limit) + '...'
  } else {
    return value
  }
})

Vue.filter('firstName', (name) => {
  let firstName = ''
  if (name) {
    try {
      let arr = name.split(' ')
      if (arr.length === 1) {
        firstName = arr[0]
      } else if (arr.length === 2) {
        firstName = arr[0] + ' ' + arr[1].substring(0, 1) + '.'
      }

      if (!firstName && arr.length > 0) {
        firstName = arr[0]
      }
    } catch (err) {
      console.log(err)
    }
  }
  return firstName
})

Vue.filter('vipStatus', (orderCount, height) => {
  let result = ''
  if (orderCount >= 100) {
    result = `<img src="/images/vip-gold-plus.jpg" style="height: ${height}px"></img>`
  } else if (orderCount >= 50) {
    result = `<img src="/images/vip-gold.jpg" style="height: ${height}px"></img>`
  } else if (orderCount >= 20) {
    result = `<img src="/images/vip-blue.jpg" style="height: ${height}px"></img>`
  } else if (orderCount >= 10) {
    result = `<img src="/images/vip-green.jpg" style="height: ${height}px"></img>`
  }
  return result
})

Vue.filter('activeStatus', (active) => {
  let html = ''
  switch (active) {
    case 0:
      html = '<span class="text-danger"><span class="mr-1"><i class="fas fa-circle"></i></span>offline</span>'
      break
    case 1:
      html = '<span class="text-success"><span class="mr-1"><i class="fas fa-circle"></i></span>online</span>'
      break
    case 2:
      html = '<span class="text-muted"><span class="mr-1"><i class="fas fa-circle"></i></span>pause</span>'
      break
  }
  return html
})

Vue.filter('professionalGroupId', (groupId, status = 1, showFullGroupName = false) => {
  if (groupId === null || groupId === '' || typeof groupId === 'undefined') {
    return ''
  }
  var group = ''
  var htmlClass = ''
  if (groupId === -1 || status === 0) {
    return '<span class="badge badge-danger">ปลดแล้ว</span>'
  }
  if (showFullGroupName) {
    group = 'กลุ่ม '
  }
  if (groupId === 1) {
    group += 'A'
    htmlClass = 'badge-success'
  } else if (groupId === 2) {
    group += 'B'
    htmlClass = 'badge-warning'
  } else if (groupId === 0) {
    group += '0'
    htmlClass = 'badge-secondary'
  } else if (groupId === 3) {
    group += 'C'
    htmlClass = 'badge-warning'
  } else if (groupId === 4) {
    group += 'H'
    htmlClass = 'badge-primary'
  }
  return `<span class="badge ${htmlClass}">${group}</span>`
})

Vue.filter('pValue', (pValue) => {
  let result = ''
  if (pValue === '' || pValue === undefined || pValue === null) {
    return result
  }
  pValue = Number(pValue)
  switch (pValue) {
    case -1:
      result = 'ไม่ระบุ'
      break
    case 0:
      result = 'P00 : Lost Sale'
      break
    case 40:
      result = 'P40 : Low P'
      break
    case 50:
      result = 'P50 : P'
      break
    case 80:
      result = 'P80 : Hi-P'
      break
    case 90:
      result = 'P90 : On-Hand'
      break
    case 100:
      result = 'P100 : Close Sale'
      break
  }
  return result
})

Vue.filter('platform', (platform) => {
  let result = ''
  switch (platform) {
    case 'website':
      result = '<i class="fas fa-globe-asia" style="color: #0288D1;"></i>'
      break
    case 'ios':
      result = '<i class="fab fa-apple"></i>'
      break
    case 'android':
      result = '<i class="fab fa-android" style="color: #8BC34A;"></i>'
      break
    case 'chat':
      result = '<i class="fab fa-line"  style="color: #53B535;"></i>'
      break
    default:
      result = '<i class="fas fa-globe-asia" style="color: #0288D1;"></i>'
  }
  return result
})

Vue.filter('prettyNumber', (value) => {
  let result = Number(value)
  if (result % 1.0 !== 0) {
    return result.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',')
  } else {
    return result.toFixed(0).replace(/\B(?=(\d{3})+(?!\d))/g, ',')
  }
})
